module.exports = __webpack_public_path__ + "img/106.2c966c7c.jpg";